// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/special_day.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schedules_v1_resources_cycle_day_effect } from "./cycle_day_effect_pb.js";

/**
 * Describes the file studyo/today/schedules/v1/resources/special_day.proto.
 */
export const file_studyo_today_schedules_v1_resources_special_day = /*@__PURE__*/
  fileDesc("CjVzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9zcGVjaWFsX2RheS5wcm90bxIjc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMiwgIKClNwZWNpYWxEYXkSCgoCaWQYASABKAkSDQoFdGl0bGUYAiABKAkSGAoQaXNfdGl0bGVfdmlzaWJsZRgDIAEoCBIOCgZzeW1ib2wYBCABKAkSGQoRaXNfc3ltYm9sX3Zpc2libGUYBSABKAgSDQoFY29sb3IYBiABKAkSTQoQY3ljbGVfZGF5X2VmZmVjdBgHIAEoDjIzLnN0dWR5by50b2RheS5zY2hlZHVsZXMudjEucmVzb3VyY2VzLkN5Y2xlRGF5RWZmZWN0EhEKCWN5Y2xlX2RheRgIIAEoBRIbChNwZXJpb2Rfc2NoZWR1bGVfaWRzGAkgAygJEh0KFWlzX2VuZF9vZl90ZXJtX21hcmtlchgKIAEoCBIQCghyZXZpc2lvbhgLIAEoBRIVCg1zaG91bGRfZGVsZXRlGAwgASgIQiuqAihTdHVkeW8uVG9kYXkuU2NoZWR1bGVzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_studyo_today_schedules_v1_resources_cycle_day_effect]);

/**
 * Describes the message studyo.today.schedules.v1.resources.SpecialDay.
 * Use `create(SpecialDaySchema)` to create a new message.
 */
export const SpecialDaySchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_special_day, 0);

